import { types as sdkTypes } from '../util/sdkLoader';

const { LatLng, LatLngBounds } = sdkTypes;

export const CUSTOM_DEFAULT_LOCATION = {
  bounds: new LatLngBounds(
    new LatLng(52.54171205, 22.87360127),
    new LatLng(35.86457571, -5.13899985)
  ),
};

// An array of locations to show in the LocationAutocompleteInput when
// the input is in focus but the user hasn't typed in any search yet.
//
// Each item in the array should be an object with a unique `id` (String) and a
// `predictionPlace` (util.types.place) properties.
//
// NOTE: these are highly recommended, since they
//       1) help customers to find relevant locations, and
//       2) reduce the cost of using map providers geocoding API

// Note: first default location is used throughout the app
const defaultLocations = [
  {
    id: 'default-alps',
    predictionPlace: {
      address: 'Alps',
      bounds: new LatLngBounds(new LatLng(49.104925, 17.081178), new LatLng(43.133132, 4.278328)),
    },
    search: `?address=Alps&bounds=49.104925%2C17.081178%2C43.133132%2C4.278328`,
  },
  {
    id: 'default-lombardia',
    predictionPlace: {
      address: 'Lombardia, Italy',
      bounds: new LatLngBounds(new LatLng(46.652081, 11.509959), new LatLng(44.657432, 8.489558)),
    },
    search: `?address=Lombardia%2C%20Italy&bounds=46.652081%2C11.509959%2C44.657432%2C8.489558`,
  },
  {
    id: 'default-switzerland',
    predictionPlace: {
      address: 'Switzerland',
      bounds: new LatLngBounds(new LatLng(47.808380, 10.492200), new LatLng(45.817995, 5.956040)),
    },
    search: `?address=Switzerland&bounds=47.808380%2C10.492200%2C45.817995%2C5.956040`,
  },
];
export default defaultLocations;
